const Error = () => (
	<section id="error-section" className="error-section" style="background-image: url('../../assets/images/error.jpg')" >
		<div className="section-position">
			<div className="section-table">
				<div className="section-table-cell">
					<div className="section-table-data with-bg">
						<h2>Error</h2>
						<p>An Error Occur</p>
					</div>
				</div>
			</div>
		</div>
	</section>
);

export default Error;

